module.exports = __webpack_public_path__ + "img/wome-banner.b38fe108.png";